module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium-b29798d67d335051fff765ec6fd85094.webp";